import { ChannelConfigType } from 'src/lib/types/channels'

export type IntegrationsType = {
  google: GoogleAnalyticsType
  ga: GoogleAnalytics4Type
  gtm: GoogleTagManagerType
  facebook: FacebookCombinedAnalyticsType
  webengage: WebengageAnalyticsType
  googleAds: GoogleAdsType
  contlo: ContloAnalyticsType
  orderConfirmation: OrderConfirmationScriptType
  clevertap: ClevertapAnalyticsType
  limechat: LimechatAnalyticsType
  moengage: MoengageAnalyticsType
  klaviyo: KlaviyoAnalyticsType
  omnisend: OmnisendAnalyticsType
  aisensy?: AisensyAnalyticsType
  ycloud?: YcloudAnalyticsType
  drivemetadata: DriveMetadataAnalyticsType
  webhooks: WebhooksType
  shipRocket: ShipRocketType
  clickPost: ClickPostType
  popCoins: PopCoinsConfig
  iThinkLogistics: iThinkLogisticsType
  additionalScripts: AdditionalScriptsType
}

export type AdditionalScriptsType = {
  script: string
}

export type ShipRocketType = {
  enabled: boolean
  provider: string
  email: string
  password: string
  pickup_pincode: string
  shipRocketUIFields: EtdProviderConfigItem[]
}

export type ClickPostType = {
  enabled: boolean
  provider: string
  username: string
  key: string
  pickup_pincode: string
  clickPostUIFields: EtdProviderConfigItem[]
}

export type iThinkLogisticsType = {
  enabled: boolean
  provider: string
  access_token: string
  secret_key: string
  pickup_pincode: string
  iThinkLogisticsUIFields: EtdProviderConfigItem[]
}

export type EtdProviderConfigItem = {
  name: string
  label: string
  type: string
  required: boolean
  masked: boolean
}

export type GoogleAnalyticsType = {
  enabled: boolean
  channels?: ChannelConfigType[]
}

export type GoogleAnalytics4Type = {
  enabled: boolean
  measurementId: string
  apiSecret: string
  channels?: ChannelConfigType[]
}

export type GoogleTagManagerType = {
  enabled: boolean
  containerId: string
  channels?: ChannelConfigType[]
}

export type FacebookCombinedAnalyticsType = {
  enabled: boolean
  pixels: FacebookCombinedAnalyticsPixelType[]
}

export type FacebookCombinedAnalyticsPixelType = {
  enabled: boolean
  pixelId: string
  conversionsEnabled: boolean
  apiToken: string
  channels?: ChannelConfigType[]
}

export type WebengageAnalyticsType = {
  enabled: boolean
  licenseCode: string
  apiKey: string
  isIndiaDatacenter: boolean
  channels?: ChannelConfigType[]
}

export type GoogleAdsType = {
  enabled: boolean
  tags: GoogleAdsTagsType[]
}

export type GoogleAdsTagsType = {
  conversionId: string
  conversionLabel: string
  enhancedConversionEnabled: boolean
  channels?: ChannelConfigType[]
}
export type ContloAnalyticsType = {
  apiKey: string
  enabled: boolean
  channels?: ChannelConfigType[]
}

export type OrderConfirmationScriptType = {
  enabled: boolean
  script: string
}

export type MoengageAnalyticsType = {
  enabled: boolean
  appId: string
  dataCenter: string
  dataAPIId: string
  dataAPIKey: string
  customerIdType?: string
  channels?: ChannelConfigType[]
}

export type ClevertapAnalyticsType = {
  enabled: boolean
  accountId: string
  passcode: string
  region: string
  identity: string
  channels?: ChannelConfigType[]
}

export type KlaviyoAnalyticsType = {
  enabled: boolean
  apiKey: string
  channels?: ChannelConfigType[]
}

export type OmnisendAnalyticsType = {
  enabled: boolean
  apiKey: string
  channels?: ChannelConfigType[]
}

export type AisensyAnalyticsType = {
  enabled: boolean
  apiKey: string
  channels?: ChannelConfigType[]
}

export type YcloudAnalyticsType = {
  enabled: boolean
  apiKey: string
  channels?: ChannelConfigType[]
}

export type DriveMetadataAnalyticsType = {
  enabled: boolean
  drivemetadata: DriveMetadataItemType[]
}

export type DriveMetadataItemType = {
  clientId: string
  workspaceId: string
  appId: string
  webhookToken: string
  enabled: boolean
  channels?: ChannelConfigType[]
}
export type LimechatAnalyticsType = {
  enabled: boolean
  limechat: LimechatType[]
}
export type LimechatType = {
  enabled?: boolean
  channels?: ChannelConfigType[]
  'x-limechat-uat'?: string
  'x-fb-account-id'?: string
}

export type WebhooksType = {
  enabled: boolean
  webhooks: WebhookType[]
}

export type WebhookType = {
  enabled: boolean
  url: string
  eventName: string
  authorization?: string
  headers: any
  channels?: ChannelConfigType[]
}

export type AnalyticsSettingsType = 'google'

export type DatacenterOption = {
  value: string
  label: string
}

export type IdentityOptionType = {
  value: string
  label: string
}

export type IntegrationsMetricType =
  | 'google'
  | 'ga'
  | 'facebook'
  | 'fb_conversion'
  | 'webengage'
  | 'contlo'
  | 'order_confirmation_scripts'
  | 'google_ad'
  | 'clevertap'
  | 'moengage'
  | 'klaviyo'
  | 'omnisend'
  | 'aisensy'
  | 'ycloud'
  | 'drivemetadata'
  | 'webhooks'
  | 'limechat'
  | 'gtm'
  | 'thank-you-page'

export type ShipRocketUIFieldsType = {
  enabled: boolean
  provider: string
  email: string
  password: string
  pickup_pincode: string
}

export type FieldErrorState = {
  error: string
  errorStatus: boolean
}

export type ShipRocketErrorType = {
  email: FieldErrorState
  pickup_pincode: FieldErrorState
}

export type ClickPostErrorType = {
  pickup_pincode: FieldErrorState
}

export type ClickPostUIFieldsType = {
  enabled: boolean
  provider: string
  username: string
  key: string
  pickup_pincode: string
}

export type iThinkLogisticsUIFieldsType = {
  enabled: boolean
  provider: string
  access_token: string
  secret_key: string
  pickup_pincode: string
}

export type PopCoinsConfig = {
  loyaltyProvider: string
  metadata: {
    authToken: string
  }
  isActive: boolean
}

export enum RewardsProvider {
  POP_COINS = 'POP_COINS',
  SHOPFLO = 'SHOPFLO',
  YOTPO = 'YOTPO',
  RETENZY = 'RETENZY',
  NECTOR = 'NECTOR',
  YOUR_TOKEN = 'YOUR_TOKEN',
  FLITS = 'FLITS',
  CASA = 'CASA',
  REWARD_RALLY = 'REWARD_RALLY',
  E_REWARDS = 'E_REWARDS'
}

/** A single credential field collected by a loyalty connect form. */
export type LoyaltyFieldDef = {
  /** snake_case key sent inside provider_metadata to the rewards engine */
  key: string
  label: string
  isRequired?: boolean
}

/**
 * Generic loyalty provider config shared by the bespoke connect forms.
 * `metadata` holds provider_metadata as a flat key→value map so one
 * fetch/save helper can serve every provider regardless of field count.
 */
export type LoyaltyConfig = {
  loyaltyProvider: string
  metadata: Record<string, string>
  isActive: boolean
}

export type ShippingErrorsType = {
  [key: string]: {
    error: string
    errorStatus: boolean
  }
}

export type ShippingField = {
  name: string
  label: string
  type: string
  required: boolean
  masked: boolean
  display_name: string
}

export type ShippingIntegrationConfigType = {
  enabled: boolean
  provider: string
  fields: ShippingField[]
  values: Record<string, string | boolean>
}

export type ShippingProvider = 'DELHIVERY' | 'SHIP_DELIGHT' | 'PRO_SHIP' | 'EASY_ECOM_CLICK_POST'

